/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCreditApplicationSupportingDocuments_creditApplication_CreditApplication_supportingDocuments_CreditApplicationDocument = { readonly __typename: 'CreditApplicationDocument', readonly documentType: _Types.CreditDocument, readonly documentUuid: string, readonly isReRequested: boolean, readonly statusMessage: string | null, readonly fileName: string | null, readonly status: string | null, readonly signedUrl: string | null, readonly unsignedPath: string | null };

export type GetCreditApplicationSupportingDocuments_creditApplication_CreditApplication_requiredDocs_CreditApplicationDocument = { readonly __typename: 'CreditApplicationDocument', readonly documentType: _Types.CreditDocument, readonly documentUuid: string, readonly isReRequested: boolean, readonly statusMessage: string | null, readonly fileName: string | null, readonly status: string | null, readonly signedUrl: string | null, readonly unsignedPath: string | null };

export type GetCreditApplicationSupportingDocuments_creditApplication_CreditApplication = { readonly __typename: 'CreditApplication', readonly salesforceCreditId: string, readonly supportingDocuments: ReadonlyArray<GetCreditApplicationSupportingDocuments_creditApplication_CreditApplication_supportingDocuments_CreditApplicationDocument> | null, readonly requiredDocs: ReadonlyArray<GetCreditApplicationSupportingDocuments_creditApplication_CreditApplication_requiredDocs_CreditApplicationDocument> | null };

export type GetCreditApplicationSupportingDocuments_Query = { readonly __typename: 'Query', readonly creditApplication: GetCreditApplicationSupportingDocuments_creditApplication_CreditApplication | null };


export type GetCreditApplicationSupportingDocumentsVariables = _Types.Exact<{
  creditApplicationId: _Types.Scalars['ID']['input'];
}>;


export type GetCreditApplicationSupportingDocuments = GetCreditApplicationSupportingDocuments_Query;


export const GetCreditApplicationSupportingDocumentsDocument = gql`
    query GetCreditApplicationSupportingDocuments($creditApplicationId: ID!) {
  creditApplication(creditApplicationId: $creditApplicationId) {
    salesforceCreditId
    supportingDocuments {
      documentType
      documentUuid
      isReRequested
      statusMessage
      fileName
      status
      signedUrl
      unsignedPath
    }
    requiredDocs {
      documentType
      documentUuid
      isReRequested
      statusMessage
      fileName
      status
      signedUrl
      unsignedPath
    }
  }
}
    `;

/**
 * __useGetCreditApplicationSupportingDocuments__
 *
 * To run a query within a React component, call `useGetCreditApplicationSupportingDocuments` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditApplicationSupportingDocuments` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditApplicationSupportingDocuments({
 *   variables: {
 *      creditApplicationId: // value for 'creditApplicationId'
 *   },
 * });
 */
export function useGetCreditApplicationSupportingDocuments(baseOptions: Apollo.QueryHookOptions<GetCreditApplicationSupportingDocuments, GetCreditApplicationSupportingDocumentsVariables> & ({ variables: GetCreditApplicationSupportingDocumentsVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditApplicationSupportingDocuments, GetCreditApplicationSupportingDocumentsVariables>(GetCreditApplicationSupportingDocumentsDocument, options);
      }
export function useGetCreditApplicationSupportingDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditApplicationSupportingDocuments, GetCreditApplicationSupportingDocumentsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditApplicationSupportingDocuments, GetCreditApplicationSupportingDocumentsVariables>(GetCreditApplicationSupportingDocumentsDocument, options);
        }
export function useGetCreditApplicationSupportingDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCreditApplicationSupportingDocuments, GetCreditApplicationSupportingDocumentsVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCreditApplicationSupportingDocuments, GetCreditApplicationSupportingDocumentsVariables>(GetCreditApplicationSupportingDocumentsDocument, options);
        }
export type GetCreditApplicationSupportingDocumentsHookResult = ReturnType<typeof useGetCreditApplicationSupportingDocuments>;
export type GetCreditApplicationSupportingDocumentsLazyQueryHookResult = ReturnType<typeof useGetCreditApplicationSupportingDocumentsLazyQuery>;
export type GetCreditApplicationSupportingDocumentsSuspenseQueryHookResult = ReturnType<typeof useGetCreditApplicationSupportingDocumentsSuspenseQuery>;
export type GetCreditApplicationSupportingDocumentsQueryResult = Apollo.QueryResult<GetCreditApplicationSupportingDocuments, GetCreditApplicationSupportingDocumentsVariables>;